import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
    <circle cx="12" cy="12.491" r="12" fill="#000"></circle>
    <path
      fill="#fff"
      d="m13.439 11.308 5.63-6.546h-1.334l-4.89 5.684-3.904-5.684H4.437l5.905 8.594-5.905 6.864h1.334l5.164-6.002 4.123 6.002h4.504zm-1.828 2.124-.599-.856-4.76-6.81h2.05l3.841 5.496.599.856 4.993 7.143h-2.049z"
    ></path>
  </svg>
);

export default SvgIcon;
